






















































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxTextArea } from 'devextreme-vue/text-area';
import { DxSelectBox } from 'devextreme-vue/select-box';
import { DxTextBox } from 'devextreme-vue/text-box';
import { DxButton } from 'devextreme-vue/button';
import { DxForm, DxItem, DxGroupItem, DxLabel } from 'devextreme-vue/form'
import { DxLookup } from 'devextreme-vue/lookup'
import { AnalysisTriggerRuleDto } from '@/models/analysis-triggers/AnalysisTriggerRuleDto';
import { AnalysisTriggerRuleTypeDto } from '@/models/analysis-triggers/AnalysisTriggerRuleTypeDto';
import { SelectOption } from '@/models/SelectOption';
import Form from 'devextreme/ui/form';
import dxForm from 'devextreme/ui/form';
import _, { isNull, isUndefined } from 'lodash';

@Component({
  components: {
    DxPopup,
    DxTextArea,
    DxToolbarItem,
    DxSelectBox,
    DxTextBox,
    DxButton,
    DxForm,
    DxItem,
    DxLookup,
    DxGroupItem,
    DxLabel
  }
})
export default class AnalysisTriggerRuleAddEdit extends Vue {

  @Prop({ required: true })
  visible!: boolean;

  @Prop({ default: '40%' })
  width!: number | string;

  @Prop({ default: '95%' })
  height!: number | string;

  @Prop()
  analysisTriggerRule!: AnalysisTriggerRuleDto;

  @Prop({required: true})
  analysisTriggerTypes!: Array<AnalysisTriggerRuleTypeDto>;

  @Prop({required: true})
  phaseTypes!: Array<SelectOption>;

  @Prop({required: true})
  filingTypes!: Array<SelectOption>;

  @Prop({required: true})
  countryList!: Array<SelectOption>;

  @Prop({required: true})
  clientList!:Array<SelectOption>;

  @Prop({required:false})
  errorMessage: string | null = null;

  $refs: Vue['$refs'] & {
      analysisRuleForm?: Form;
  } = {};

  get closeButtonOptions() {
    return {
      text: 'Close',
      type: 'normal',
      stylingMode: 'contained',
      onClick: this.close
    };
  }

  get saveButtonOptions() {
    return {
      text: 'Save',
      type: 'default',
      stylingMode: 'contained',
      onClick: this.validateAndSave
    };
  }

  private get formData() {
    return {
      AnalysisTriggerRuleId: this.analysisTriggerRule.AnalysisTriggerRuleId,
      AnalysisTriggerRuleTypeId: this.analysisTriggerRule.AnalysisTriggerRuleTypeId,
      CountryId: this.analysisTriggerRule.CountryId || '',
      CountryCode: this.analysisTriggerRule.CountryCode,
      FilingTypeId: this.analysisTriggerRule.FilingTypeId || '',
      FilingTypeName: this.analysisTriggerRule.FilingTypeName,
      ClientId: this.analysisTriggerRule.ClientId || '',
      ClientName: this.analysisTriggerRule.ClientName,
      CreatedDate: this.analysisTriggerRule.CreatedDate,
      CreatedById: this.analysisTriggerRule.CreatedById,
      CreatedBy: this.analysisTriggerRule.CreatedBy,
      RuleTypeName: this.analysisTriggerRule.RuleTypeName,
      RuleName: this.analysisTriggerRule.RuleName,
      Amount: isUndefined(this.analysisTriggerRule.Amount) || isNull(this.analysisTriggerRule.Amount) ? '': this.analysisTriggerRule.Amount,
      Number: isUndefined(this.analysisTriggerRule.Number) || isNull(this.analysisTriggerRule.Number) ? '': this.analysisTriggerRule.Number,
      Notes:this.analysisTriggerRule.Notes,
      PhaseType1Id: this.analysisTriggerRule.PhaseType1Id,
      Phase1Name: this.analysisTriggerRule.Phase1Name,
      PhaseType2Id: this.analysisTriggerRule.PhaseType2Id,
      Phase2Name: this.analysisTriggerRule.Phase2Name
    } as AnalysisTriggerRuleDto 
  }

  private set formData(value) {
    this.$emit('update:analysisTriggerRule',value);
  }

  onHiding() {
    this.close();
  }

  private close() {
    this.$emit('hiding');
  }

  public validateAndSave() {
    const form = this.dxForm as dxForm;
    if(form) {
      let validated = form.validate();
      if(validated.isValid) {
        this.$emit('save-and-hide', _.cloneDeep(this.formData));
      }
    }
  }

  get analysisTriggerRuleType(): any {
      return {
        "placeholder" : "Select a Rule Type",
        "dataSource" : this.analysisTriggerTypes,
        "displayExpr": "RuleTypeName",
        "valueExpr": "AnalysisTriggerRuleTypeId",
        "searchEnabled": true,
        "popupHeight": this.getPopupHeight,
        "onSelectionChanged": this.ruleTypeChanged
      };
  }

  get filingTypeOption(): any {
      return {
        "placeholder" : "Select a Filing Type",
        "dataSource" : this.filingTypes,
        "displayExpr": "text",
        "valueExpr": "value"
      };
  }

  get clientListOption(): any {
      return {
        "placeholder" : "Select a Client",
        "dataSource" : this.clientList,
        "displayExpr": "text",
        "valueExpr": "value",
        "searchEnabled": true,
        "popupHeight": this.getPopupHeight
      };
  }

  get countryListOption(): any {
      return {
        "placeholder" : "Select a Country",
        "dataSource" : this.countryList,
        "displayExpr": "text",
        "valueExpr": "value",
        "popupHeight": this.getPopupHeight
      };
  }

  get phaseTypeOption(): any {
      return {
        "placeholder" : "Select a Phase",
        "dataSource" : this.phaseTypes,
        "displayExpr": "text",
        "valueExpr": "value",
        "popupHeight": this.getPopupHeight
      };
  }

  get showForm(): boolean {
    if(this.formData) {
      return true;
    }
    return false;
  }

  get title(): string {
    if(this.formData && this.formData.AnalysisTriggerRuleId) {
      return 'Edit Analysis Trigger';
    }
    return 'Add Analysis Trigger';
  }

  getPopupHeight(): number {
      return window.innerHeight / 2;
  }

  private phaseType1Required: boolean = false;
  private phaseType2Required: boolean = false;
  private numberRequired: boolean = false;
  private amountRequired: boolean = false;

  private ruleTypeChanged(newValue: any) {
    if(newValue && newValue.selectedItem) {
      let ruleType = this.analysisTriggerTypes.find(x=>x.AnalysisTriggerRuleTypeId == newValue.selectedItem.AnalysisTriggerRuleTypeId);
      if(ruleType) {
        this.phaseType1Required = ruleType.Phase1Required;
        this.phaseType2Required = ruleType.Phase2Required;
        this.numberRequired = ruleType.NumberRequired;
        this.amountRequired = ruleType.AmountRequired;
        return;
      }
    }

    this.phaseType1Required = false;
    this.phaseType2Required = false;
    this.numberRequired = false;
    this.amountRequired = false;
  }

  private updateFormData(e: any) {
    console.log(this.updateFormData);
    this.formData = e.component.option('formData');
  }

  private get dxForm() {
      return ((this.$refs.analysisRuleForm as Form).instance as any); 
  }
}
